"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.condition = void 0;
exports.getConditionByName = getConditionByName;
const lodash_1 = __importDefault(require("lodash"));
const types_1 = require("../../types");
const { ConditionEnum } = types_1.Vehicle;
exports.condition = [
    {
        id: ConditionEnum.New,
        name: 'New',
        value: ConditionEnum.New,
    },
    {
        id: ConditionEnum.Used,
        name: 'Used',
        value: ConditionEnum.Used
    },
    {
        id: ConditionEnum.Certified,
        name: 'Certified Used',
        value: ConditionEnum.Certified,
    },
    {
        id: ConditionEnum.Repairable,
        name: 'Repairable',
        value: ConditionEnum.Repairable
    }
];
function getConditionByName(name) {
    return lodash_1.default.find(exports.condition, x => {
        return lodash_1.default.includes(x.name.toLowerCase(), lodash_1.default.toLower(name));
    });
}
